import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
import { Map as ImmutableMap } from 'immutable';
import { useContext } from 'react';
import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { testDynamicFilterFamily } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import Equal from 'customer-data-filters-ui/filterQueryFormat/operator/Equal';
import { makeImportMembershipField } from '../converters/specialFields/ImportMembershipField';
import { makeListMembershipField } from '../converters/specialFields/ListMembershipField';
import { makeWorkflowStatusField } from '../converters/specialFields/WorkflowStatusField';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
const convertDSFieldRecordsIntoOptions = fields => {
  return fields.valueSeq().toArray().map(field => {
    return PropertyOptionRecord({
      value: field.name,
      label: field.label
    });
  });
};
const getAssetMembershipStatusField = (filterFamily, fields) => {
  const options = convertDSFieldRecordsIntoOptions(fields);
  if (testDynamicFilterFamily(DSAssetFamilies.IN_LIST, filterFamily)) {
    return makeListMembershipField(options);
  }
  if (testDynamicFilterFamily(DSAssetFamilies.IMPORT, filterFamily)) {
    return makeImportMembershipField(options);
  }
  if (DSAssetFamilies.WORKFLOW === filterFamily) {
    return makeWorkflowStatusField(options);
  }
  return undefined;
};
export const useAssetMembershipFilter = (filterFamily, condition) => {
  const {
    data
  } = useContext(SegmentationFiltersInstanceContext);
  const fields = data.get(filterFamily) || ImmutableMap();
  const statusCondition = Equal.of(
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'DSFieldRecordInstance | undefine... Remove this comment to see the full error message
  getAssetMembershipStatusField(filterFamily, fields), condition.field.name);
  return {
    statusCondition
  };
};